import baseConfig from './baseConfig'
import {clientCsaveExtensions} from './csaveConfigs'
import type {DSConfig} from '../dsConfig'

const config = {
    ...baseConfig,
    runStylesGC: false,
    supportMobile: false,
    postUpdateOperation: false,
    loadsMiniSiteManager: true,
    documentDataFixer: 'responsiveDocument',
    isReadOnly: false,
    noUndo: false,
    disableCommonConfig: false,
    modulesList: [
        'branchesPublicAPI',
        'accessibilityPublicAPI',
        'dataModelPublicAPI',
        'featuresPublicAPI',
        'slotsPublicAPI',
        'statesPublicAPI',
        'triggersPublicAPI',
        'reactionsPublicAPI',
        'documentModePublicAPI',
        'remoteStructureMetaDataPublicApi',
        'renderPluginsPublicApi',
        'savePublicAPI',
        'componentPublicAPI',
        'innerElementsPublicAPI',
        'refComponentPublicAPI',
        'componentDetectorPublicAPI',
        'responsivePublicAPI',
        'breakpointsPublicAPI',
        'namedRangesPublicAPI',
        'responsiveStylesPublicAPI',
        'siteMetadataPublicAPI',
        'themePublicAPI',
        'globalStylesPublicAPI',
        'cssStylePublicAPI',
        'snapshotPublicAPI',
        'pagePublicAPI',
        'scrollAnchorsPublicAPI',
        'siteSegmentsPublicAPI',
        'componentsMetaDataPublicAPI',
        'appControllerDataPublicAPI',
        'connectionsPublicAPI',
        'platformPublicAPI',
        'routersPublicAPI',
        'autosavePublicAPI',
        'stylableEditorPublicAPI',
        'biPublicAPI',
        'environmentPublicAPI',
        'actionsAndBehaviorsPublicAPI',
        'structurePublicAPI',
        'debugPublicAPI',
        'atomicScopesPublicAPI',
        'menuPublicAPI',
        'smartBoxesPublicAPI',
        'sectionOrderPublicAPI',
        'fontsPublicAPI',
        'mediaPublicAPI',
        'tpaPublicAPI',
        'pagesGroupPublicAPI',
        'siteMembersPublicAPI',
        'wixCodePublicAPI',
        'variantsPublicAPI',
        'accountPublicAPI',
        'transformationsPublicAPI',
        'transitionsPublicAPI',
        'errorsPublicAPI',
        'componentsLoaderPublicAPI',
        'appStudioWidgetsPublicAPI',
        'multilingualPublicAPI',
        'partnersPublicAPI',
        'variablesPublicAPI',
        'scopesPublicAPI',
        'patternsPublicAPI',
        'effectsPublicAPI',
        'deprecatedOldBadPerformancePublicAPI',
        'customCSSPublicAPI',
        'aiPublicAPI',
        'externalComponentsPublicAPI',
        'importExportPublicAPI',
        'responsiveFixersPublicAPI',
        'builderComponentsPublicAPI',
        'historyAPI',
        'editorFeaturesPublicAPI',
        'observablesPublicAPI'
    ],
    extensionsList: [
        ...baseConfig.extensionsList,
        'undoRedo',
        'metadata',
        'save',
        'lifecycle',
        'layoutCircuitBreaker',
        'viewerRuntime',
        'contactFormMetaData',
        'appBuilder',
        'sectionOrder',
        'documentToViewer',
        'wixapps',
        'accountInfo',
        'commonConfig',
        'seo',
        ...clientCsaveExtensions,
        'componentsByType',
        'partners',
        'componentsRegistry',
        'aiContent',
        'proactiveAssistance',
        'eventHandler',
        'fileUpload',
        'responsiveFixers',
        'measurements',
        'editorFeatures',
        'namedRanges'
    ],
    experimentalConfigOptions: {
        dm_fragments: {
            configOptions: {
                supportedFragments: {
                    ...baseConfig.experimentalConfigOptions.dm_fragments.configOptions.supportedFragments,
                    EditorFeatures: {
                        //only because we currently have an issue with initialSnapshot per fragment type
                        loadOnInit: true
                    }
                }
            }
        }
    }
}

export default config as unknown as DSConfig
